module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-body"
  }, [_c('div', {
    class: _vm.computedClassName,
    style: ({
      'background-color': _vm.bgColor
    })
  }, [_c('div', {
    staticClass: "logo-mark"
  }, [_c('svg', {
    attrs: {
      "id": "greenpark_logo",
      "width": "33",
      "height": "33",
      "viewBox": "0 0 33 33",
      "fill": "green",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    style: ({
      'fill': _vm.subColor
    }),
    attrs: {
      "id": "myPath",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.7594 0.296997C7.85226 0.296997 0.631592 7.51767 0.631592 16.4248C0.631592 25.332 7.85226 32.5526 16.7594 32.5526C25.6666 32.5526 32.8872 25.332 32.8872 16.4248C32.8872 7.51767 25.6666 0.296997 16.7594 0.296997ZM17.7055 27.199C11.0821 27.647 5.98988 15.3899 8.37926 13.009C10.5591 10.837 11.4244 11.6134 11.8337 13.4321C12.0624 14.4477 11.8927 15.6938 11.7398 16.8168C11.6069 17.7927 11.4866 18.6756 11.6515 19.2334C12.0061 20.4331 12.6146 21.3839 13.3152 21.3164C14.0159 21.2489 15.1022 19.3642 12.7643 12.1573C11.0417 6.84704 15.6649 5.01134 16.0884 6.11656C16.2796 6.6155 16.0174 7.43242 15.7094 8.39211C15.3352 9.55832 14.8933 10.9354 15.115 12.2088C15.2964 13.251 15.4695 13.8299 15.6241 14.3469C15.8139 14.9814 15.9758 15.5226 16.0909 16.7129C16.1397 17.2168 16.1162 17.8618 16.0913 18.5473C16.0284 20.2787 15.956 22.2693 17.0136 22.9027C18.4899 23.7869 19.1374 19.4874 17.7159 11.7192C16.4394 4.74359 21.0207 6.89465 21.1415 9.00927C21.2624 11.1239 21.1284 14.3007 20.2738 18.7428C19.4193 23.185 20.0408 23.5508 21.1415 22.4336C22.2423 21.3164 22.3038 20.5267 21.6661 16.1227C21.2314 13.1211 25.9298 11.5922 25.4232 15.5363C24.9132 19.5063 22.6049 26.8676 17.7055 27.199Z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "budget-text"
  }, [_c('p', {
    style: ({
      'color': _vm.subColor
    })
  }, [_vm._v("This product " + _vm._s(_vm.action))]), _vm._v(" "), _c('p', {
    style: ({
      'color': _vm.subColor
    })
  }, [_vm._v(_vm._s(_vm.amount) + " " + _vm._s(_vm.type))])])]), _vm._v(" "), _c('div', {
    staticClass: "budget-body-detail"
  }, [_c('div', {
    staticClass: "detail-layer"
  }, [_c('p', [_vm._v("Link to Public Profile\n        "), _c('span', [_c('span', {
    on: {
      "mouseover": _vm.showDiv,
      "mouseleave": _vm.hideDiv
    }
  }, [_c('svg', {
    attrs: {
      "width": "12",
      "height": "13",
      "viewBox": "0 0 12 13",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.5 9.47363H6.5V6.47363H5.5V9.47363ZM6 1.97363C3.24 1.97363 1 4.21363 1 6.97363C1 9.73363 3.24 11.9736 6 11.9736C8.76 11.9736 11 9.73363 11 6.97363C11 4.21363 8.76 1.97363 6 1.97363ZM6 10.9736C3.795 10.9736 2 9.17863 2 6.97363C2 4.76863 3.795 2.97363 6 2.97363C8.205 2.97363 10 4.76863 10 6.97363C10 9.17863 8.205 10.9736 6 10.9736ZM5.5 5.47363H6.5V4.47363H5.5V5.47363Z",
      "fill": "#3B755F"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.5 4.47363H6.5V5.47363H5.5V4.47363ZM5.5 6.47363H6.5V9.47363H5.5V6.47363Z",
      "fill": "#3B755F"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6 1.97363C3.24 1.97363 1 4.21363 1 6.97363C1 9.73363 3.24 11.9736 6 11.9736C8.76 11.9736 11 9.73363 11 6.97363C11 4.21363 8.76 1.97363 6 1.97363ZM6 10.9736C3.795 10.9736 2 9.17863 2 6.97363C2 4.76863 3.795 2.97363 6 2.97363C8.205 2.97363 10 4.76863 10 6.97363C10 9.17863 8.205 10.9736 6 10.9736Z",
      "fill": "#3B755F"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tooltip-header"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHovered || _vm.isHovered1),
      expression: "isHovered || isHovered1"
    }],
    staticClass: "tooltip-body",
    class: {
      active: _vm.isHovered
    },
    on: {
      "mouseover": _vm.showDiv1,
      "mouseleave": _vm.hideDiv1
    }
  }, [_vm._m(0)])])])]), _vm._v(" "), _c('input', {
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-layer"
  }, [_c('p', [_vm._v("Badge color")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "colorbtn1",
    on: {
      "click": function($event) {
        _vm.changeColor(1, _vm.id)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "colorbtn2",
    on: {
      "click": function($event) {
        _vm.changeColor(2, _vm.id)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "colorbtn3",
    on: {
      "click": function($event) {
        _vm.changeColor(3, _vm.id)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "colorbtn4",
    on: {
      "click": function($event) {
        _vm.changeColor(4, _vm.id)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "colorbtn5",
    on: {
      "click": function($event) {
        _vm.changeColor(5, _vm.id)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "detail-layer"
  }, [_c('p', [_vm._v("Activate badge")]), _vm._v(" "), _c('div', {
    staticClass: "ios-toggle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isChecked),
      expression: "isChecked"
    }],
    class: _vm.computedCheckBoxClassName,
    attrs: {
      "type": "checkbox",
      "id": "ios-toggle"
    },
    domProps: {
      "checked": Array.isArray(_vm.isChecked) ? _vm._i(_vm.isChecked, null) > -1 : (_vm.isChecked)
    },
    on: {
      "change": function($event) {
        _vm.handleCheckboxChange(_vm.id)
      },
      "__c": function($event) {
        var $$a = _vm.isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isChecked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isChecked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ios-toggle"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._v("\n                This widget links directly to your public profile so that you can easily share your impact with your customers. Turn it off here if you do not want the badge to link to it."), _c('br'), _c('hr', {
    staticStyle: {
      "clear": "both",
      "visibility": "hidden"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tooltip-link"
  }, [_c('a', [_vm._v("View Public Profile")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dd4f9f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BudgetDetail.vue
// module id = 96
// module chunks = 1